var $6f40c3a58f594b58$exports = {};
console.log('Hello world!');


//# sourceMappingURL=parcel2.7c58efa3.js.map
